export default __webpack_public_path__ + "static/media/pink-ribbon.3e008afb.png";